import { render, staticRenderFns } from "./SalonProcess.vue?vue&type=template&id=79e439b1&"
import script from "./SalonProcess.vue?vue&type=script&lang=js&"
export * from "./SalonProcess.vue?vue&type=script&lang=js&"
import style0 from "./SalonProcess.vue?vue&type=style&index=0&id=79e439b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports